import Axios from 'api/client';
import { Appeal } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface CreateOrUpdateAppealParams {
    name: string;
    code: string | null;
    active: boolean;
}

interface FetchAppealsParams extends FilterParams {}

const fetchAppeals = (accountId: number, params: FetchAppealsParams = {}) => {
    const { filters, ...restParams } = params;
    return Axios.post<PaginatedData<Appeal>>(`/accounts/${accountId}/get_appeals`, {
        ...filters,
        ...restParams,
    }).then(response => response.data);
};

const fetchAppealById = (accountId: number, appealId: number) =>
    Axios.get<Appeal>(`/accounts/${accountId}/appeals/${appealId}`).then(response => response.data);

const deleteAppeal = (accountId: number, appealId: number) =>
    Axios.delete(`/accounts/${accountId}/appeals/${appealId}`).then(response => response.data);

const createAppeal = (accountId: number, args: CreateOrUpdateAppealParams) =>
    Axios.post<Appeal>(`/accounts/${accountId}/appeals`, args).then(response => response.data);

const updateAppeal = (accountId: number, appealId: number, args: CreateOrUpdateAppealParams) =>
    Axios.patch<Appeal>(`/accounts/${accountId}/appeals/${appealId}`, args).then(
        response => response.data,
    );

export { fetchAppeals, fetchAppealById, deleteAppeal, createAppeal, updateAppeal };
export type { FetchAppealsParams };
